import { ParamMap } from '@angular/router';
import {
  FieldExtraConfig,
  FieldInputConfig,
  FieldStyleConfig,
  SearchEngineField,
  SearchEngineFieldType,
} from '@domains/search-engine/search-engine-field';

export class SearchEngineFieldCheckbox extends SearchEngineField<boolean> {
  readonly type = SearchEngineFieldType.Checkbox;

  constructor(inputConfig: FieldInputConfig, inputStyle?: FieldStyleConfig, extraConfig?: FieldExtraConfig) {
    super(inputConfig, extraConfig, inputStyle);
  }

  valueToQueryParams(value: boolean): { [key: string]: boolean } {
    if (value === true) {
      return {
        [this.name]: value,
      };
    }
    return {};
  }
  paramMapToValue(paramMap: ParamMap): boolean {
    return !!super.paramMapToValue(paramMap);
  }
}
